// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconNumber9 = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M12 4a8 8 0 100 16 8 8 0 000-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12"
    />,
    <path d="M8.74 14.424c.21 1.624 1.37 2.786 3.26 2.786 2.548 0 3.766-2.1 3.766-5.614 0-3.066-1.218-4.802-3.654-4.802-2.058 0-3.486 1.414-3.486 3.402 0 1.974 1.246 3.304 3.136 3.304 1.134 0 1.89-.476 2.296-.952h.028c-.042 1.68-.602 3.178-2.058 3.178-.938 0-1.442-.588-1.554-1.358zm3.401-2.338c-1.064 0-1.792-.784-1.792-1.904 0-1.092.728-1.876 1.778-1.876 1.092 0 1.806.756 1.806 1.904 0 1.134-.742 1.876-1.792 1.876" />
  );
export default SvgIconNumber9;
